module.exports = __webpack_public_path__ + "static/media/Plage.a9ac5068.m4a";